const processUrlKey = (urlKey: string) =>
  typeof urlKey === "string" ? `/${urlKey}.html` : "/";

export default processUrlKey;
